module.exports = __webpack_public_path__ + "assets/GTAmerica-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Regular.woff
// module id = 1016
// module chunks = 19